<template>
  <CTABottomBar
    custom-footer-class="ecommerce-cta-footer"
    custom-button-class="ecommerce-cta-footer__button"
    :reserve-space="false"
  />
</template>

<style>
.ecommerce-cta-footer {
  border-top: none !important;
}

.ecommerce-cta-footer .ecommerce-cta-footer__button {
  min-height: 48px !important;
  padding: 12px 20px !important;
}

.ecommerce-cta-footer .ecommerce-cta-footer__button.q-btn--outline {
  color: var(--theme-color-primary) !important;
}

.ecommerce-cta-footer .ecommerce-cta-footer__button.q-btn--outline::before {
  border-color: var(--theme-color-primary) !important;
}

.ecommerce-cta-footer .ecommerce-cta-footer__button.q-btn--outline .q-btn__content,
.ecommerce-cta-footer .ecommerce-cta-footer__button.q-btn--outline .q-icon,
.ecommerce-cta-footer .ecommerce-cta-footer__button.q-btn--outline span {
  color: inherit !important;
}
</style>
